var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-btn transition",attrs:{"noprint":""}},[_c('router-link',{staticClass:"gallery-btn-buttom",attrs:{"to":{ path: '/gallery', hash: '#gallery' }}},[_c('img',{staticClass:"gallery-btn-img",attrs:{"src":"https://new-web-site-bucket.s3.us-east-1.amazonaws.com/website/offers/backgroundOffer.svg","alt":"Register"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }